import React from 'react';
import ReviewItemCard from './ReviewItemCard';

const WalkthroughCard = ({id, title, selected, onToggle, problemPreview, stepTrack, previewButton, onPreview}) => (
    <ReviewItemCard
        id={id}
        text={title}
        checked={selected}
        onToggle={onToggle}
        meta={problemPreview}
        steps={stepTrack}
        onPreview={previewButton ? onPreview : undefined}
    />
);

export default WalkthroughCard;
